// extracted by mini-css-extract-plugin
export default {"Controls":"Controls_Controls__tgcST","Controls__subControls":"Controls_Controls__subControls__eFo4j","Controls__mainBtn":"Controls_Controls__mainBtn__+FZ+W"};